enum ShareType {
  WHTAS_APP = 'WhatsApp',
  Email = 'Email',
};

export default ShareType;
